module.exports = __webpack_public_path__ + "img/LOGO.86f5a5da.png";